<template>
  <div class="main">
    <el-dialog
      :title="openData.title"
      :visible.sync="openData.state"
      :close-on-click-modal="false"
      width="700px"
      class="dialog_container"
      @close="dialogVisibleClone"
    >
      <div class="dialog_content">
        <el-form
          :disabled="openData.title == '查看'"
          label-position="left"
          label-width="110px"
          ref="formData"
          :model="formData"
          :rules="formDataRules"
        >
          <el-form-item label="补助标题：" prop="subsidiesTitle">
            <el-input
              placeholder="请输入标题"
              v-model="formData.subsidiesTitle"
            ></el-input>
          </el-form-item>
          <el-form-item label="补助时间：" prop="subsidiesTitle">
            <el-date-picker
              style="width: 100%"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="formData.subsidiesTime"
              type="datetime"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="补助单位：" prop="subsidiesUnit">
            <el-input
              placeholder="请输入补助单位"
              v-model="formData.subsidiesUnit"
            ></el-input>
          </el-form-item>
          <el-form-item label="补助金额：" prop="subsidiesAmount">
            <el-input
              placeholder="请输入补助金额"
              v-model="formData.subsidiesAmount"
              style="width: 100%"
            ></el-input>
          </el-form-item>
          <el-form-item label="内容：" prop="content">
            <el-input
              v-model.trim="formData.content"
              :autosize="{ minRows: 2 }"
              type="textarea"
              placeholder="请输入内容"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传附件：" v-if="openData.title == '新增'">
            <el-upload
              class="upload-demo"
              :action="actionUrl"
              :on-preview="handlePreview"
              :on-success="handleEnclosureSuccess"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              multiple
              :on-exceed="handleExceed"
              :file-list="fileList"
            >
              <el-button size="small" class="editcss" type="primary">上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="上传附件：" v-if="openData.title == '查看'">
            <div v-for="(item, index) in formData.enclosure" :key="index">
              <el-link :href="item.name" target="_blank">{{ item.img }}</el-link>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer dialog-footer-btn"
        v-if="openData.title != '查看'"
      >
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
        <el-button @click="dialogVisibleClone">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import baseURL from "@/api/baseURL";
export default {
  props: ["openData"],
  data() {
    return {
      formData: {
        subsidiesTitle: "",
        subsidiesTime: "",
        subsidiesUnit: "",
        subsidiesAmount: "",
        paidAmount: "",
        balance: "",
        enclosure: "",
        content: "",
      },
      fileList: [],
      actionUrl: "",
      formDataRules: {},
      orgList: [],
      levelList: [],
    };
  },
  created() {
    this.actionUrl = baseURL + "/ypt/controller/uploadController/info/uploadPhoto";
    this.formData = {
      subsidiesTitle: "",
      subsidiesTime: "",
      subsidiesUnit: "",
      subsidiesAmount: "",
      paidAmount: "",
      balance: "",
      enclosure: "",
      content: "",
    };
    if (this.openData.title == "新增") {
    } else {
      this.dataInfos();
    }
  },
  methods: {
    // 详情页信息
    dataInfos() {
      const self = this;
      let params = {
        id: self.openData.id,
      };
      this.$http
        .request({
          url: "/ypt/admin/serviceFund/info/get",
          method: "POST",
          data: params,
        })
        .then(async (res) => {
          if (res.code == 200) {
            self.formData = res.content;
            if (res.content.enclosure) {
              console.log(res.content.enclosure);
              res.content.enclosure = res.content.enclosure.split(",");
              let aa = [];
              res.content.enclosure.forEach((item, index) => {
                aa.push({
                  name: item.substring(0, item.lastIndexOf("?")),
                  img: item.substring(item.lastIndexOf("?") + 1),
                });
              });
              console.log(aa);
              self.formData.enclosure = aa;
            }
            this.$message.success(res.message);
          }
        });
    },
    handleSubmit() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          if (this.openData.title == "新增" || this.openData.title == "编辑") {
            let url = "";
            let data = { ...this.formData };
            url = "/ypt/admin/serviceFund/info/save";
            this.$http
              .request({
                url: url,
                method: "POST",
                data: {
                  ...data,
                },
              })
              .then((res) => {
                if (res.code == 200) {
                  this.$message.success(res.message);
                } else {
                  this.$message.error(res.message);
                }
                this.$emit("cancleAddress", true);
              });
          }
        }
      });
      // this.$emit("cancleAddress", true)
    },
    dialogVisibleClone() {
      this.$emit("cancleAddress", false);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 附件上传
    handleEnclosureSuccess(res, file, fileList) {
      let arrs = [];
      let cont = [];
      fileList.forEach((file) => {
        arrs.push(file.name);
        if (file && file.response && file.response.content) {
          let element = file.response.content + "?" + file.name;
          console.log(element, "图片地址");
          cont.push(element);
        }
      });
      this.formData.enclosure = cont.join(",");
    },
    //上传附件
    handlePreview(res, file, fileList) {
      this.$set(this.formData, "enclosure", res.content);
    },
    handleRemove(file, fileList) {},
    handleExceed(files, fileList) {},
  },
};
</script>
<style lang="less" scoped></style>
